import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        company: '='
    },
    template: `
        <div class="heading01 type01">
            <h1>{{ 'general.Integration settings' | translate}}</h1>
        </div>
        <div class="well type02 mt2em form">
            <h2 class="h3">{{ 'integration.External sync settings' | translate }}</h2>
            <div class="row">
                <label class="label" style="min-width: 240px">{{ 'manage.Allow “Direct manager” role to be overwritten' | translate}}
                    <span class="tooltip-icon"
                          tooltip-append-to-body="true"
                          uib-tooltip="{{ 'manage.If turned off - all manually added “Direct manager” roles are not changed by integration' | translate }}"
                    >?</span>
                </label>
                <div class="items">
                    <label class="switch01">
                        <input name="switch" type="checkbox" ng-model="vm.form.model.overrideDirectManagerRoleBySync" ng-change="vm.save()">
                        <span></span>
                    </label>
                </div>
            </div>
        </div>
        <manage-settings-integration-generate-token
            token-type="vm.COMPANY_INTEGRATION_TOKEN_TYPE_ENUM.KEYS.POWER_BI"
        ></manage-settings-integration-generate-token>
        <manage-settings-integration-sso></manage-settings-integration-sso>
    `
})

export default class {
    constructor ($translate, lodash, FormFactory, $state, toastr, COMPANY_INTEGRATION_TOKEN_TYPE_ENUM) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.$state = $state;
        this.toastr = toastr;
        this.FormFactory = FormFactory;
        this.COMPANY_INTEGRATION_TOKEN_TYPE_ENUM = COMPANY_INTEGRATION_TOKEN_TYPE_ENUM;
        this.initForm();
    }

    initForm () {
        this.form = this.FormFactory.create(this.company, model => model.$update({ id: model.id, expand: 'languages' }));
        this.form.model.overrideDirectManagerRoleBySync = Boolean(this.form.model.overrideDirectManagerRoleBySync);
    }

    beforeSave () {
        this.form.model.languages = this.form.model.languages.map(language => language.language);
    }

    save () {
        this.beforeSave();
        this.form.save().then((company) => {
            this.toastr.success(this.$translate.instant('general.Changes saved'));
            this.company = company;
            this.initForm();
        }).catch((response) => {
            this.toastr.error(this.$translate.instant('general.Something went wrong'));
            this.form.invalid = true;
            this.form.saved = false;
            this.form.errors = this.parseErrors(response);
        });
    }

    parseErrors (response) {
        return response.data.reduce((original, error) => {
            if (error.path) {
                this.lodash.set(original, `${error.path}.${error.field}`, error.message);
            }
            else {
                original[error.field] = error.message;
            }
            return original;
        }, {});
    }

    generateToken () {
        this.toastr.success(this.$translate.instant('general.Token generated'));
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/settings/integration/index.js